module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlatinum@2x.6649187.jpg";